/**
 * Dev-only logger. Silenced in production builds so debug output
 * never leaks to end-user consoles and doesn't impact perf.
 *
 * Usage:
 *   import { logger } from '@/utils/logger';
 *   logger.error('Failed to fetch X:', err);
 */
const isDev = process.env.NODE_ENV !== 'production';

/* eslint-disable no-console */
export const logger = {
  log: (...args) => { if (isDev) console.log(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
};
/* eslint-enable no-console */
